import React from 'react';

const VideosTab = ({ selected, videos, t, imagesBase }) => {
  if (!videos) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{t('Videos')}</h2>
      {videos.data.map((video, index) => (
        <React.Fragment key={index}>
          <video width="500" controls>
            <source src={`${imagesBase}${video.link}`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <p>{video.description}</p>
        </React.Fragment>
      ))}
    </div>
  );
};

export default VideosTab;
